import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { api } from '../lib/api';
import { CheckCircle2, Clock } from 'lucide-react';
import DiscountBanner from '../components/DiscountBanner';
import CalendlyEmbed from '../components/CalendlyEmbed';

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState('checking');
  const [needsScheduling, setNeedsScheduling] = useState(false);
  const sessionId = params.get('session_id');

  useEffect(() => {
    if (!sessionId) { setStatus('error'); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (r.data.payment_status === 'paid') {
          setStatus('paid');
          // Determine if a live consultation needs scheduling
          try {
            const list = await api.get('/consultations');
            const matching = list.data.find(c => c.session_id === sessionId);
            if (matching && matching.modality === 'live') setNeedsScheduling(true);
          } catch {}
          return;
        }
        if (r.data.status === 'expired') { setStatus('expired'); return; }
        if (attempts >= 8) { setStatus('timeout'); return; }
        attempts++;
        setTimeout(poll, 2000);
      } catch { setStatus('error'); }
    };
    poll();
  }, [sessionId]);

  return (
    <main className="bg-stilo-bg min-h-[70vh]" data-testid="payment-success-page">
      <div className={`mx-auto px-6 py-20 ${needsScheduling ? 'max-w-3xl' : 'max-w-md text-center'}`}>
        {status === 'checking' && (<div className="text-center">
          <Clock className="w-10 h-10 mx-auto text-stilo-gold" strokeWidth={1.5} />
          <h1 className="font-serif text-4xl mt-6">Procesando tu pago…</h1>
          <p className="mt-3 text-stilo-ink2">Estamos confirmando con Stripe.</p>
        </div>)}

        {status === 'paid' && (<>
          <div className={needsScheduling ? '' : 'text-center'}>
            <CheckCircle2 className="w-12 h-12 mx-auto text-stilo-gold" strokeWidth={1.5} />
            <h1 className="font-serif text-5xl mt-6 text-center">¡Reserva confirmada!</h1>
            <p className="mt-4 text-stilo-ink2 text-center">
              {needsScheduling
                ? 'Último paso: elige día y hora para nuestra videollamada.'
                : 'Te he creado el hilo privado de tu asesoría. Te avisaré por mensaje cuando responda.'}
            </p>
          </div>

          {needsScheduling && (
            <div className="mt-10">
              <CalendlyEmbed />
            </div>
          )}

          <div className="mt-10 text-left">
            <DiscountBanner variant="hero" />
          </div>

          <div className="text-center">
            <button onClick={() => nav('/cuenta')} className="btn-stilo mt-10" data-testid="go-account">
              Ir a mis asesorías
            </button>
          </div>
        </>)}

        {(status === 'expired' || status === 'error' || status === 'timeout') && (<div className="text-center">
          <h1 className="font-serif text-4xl">No pudimos confirmar el pago</h1>
          <p className="mt-3 text-stilo-ink2">Si el cargo se realizó, aparecerá pronto en tu cuenta.</p>
          <Link to="/asesorias" className="btn-stilo mt-8 inline-flex">Volver</Link>
        </div>)}
      </div>
    </main>
  );
}
